export default __webpack_public_path__ + "images/48_1_image.jpg";